import React from 'react'
import { connect } from 'react-redux'
import HeaderTitle from '../Header/HeaderTitle'
import {
  Grid,
  Typography,
  Card,
  CircularProgress,
  AppBar,
  Tabs,
  Tab,
} from '@mui/material'
import CablingTypesTab from './CablingTypesTab'
import CablingLayoutsTab from './CablingLayoutsTab'
import PatchCableCountsTab from './PatchCableCountsTab'
import { handleFireflySendEvent } from '../Utils/FireFlyVnextHelpers'

export class Cabling extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      selectedTab: 0,
    }
    this.baseState = { ...this.state }
    this.handleTabChange = this.handleTabChange.bind(this)
    this.dialogBox = React.createRef()
  }

  async componentDidMount() {
    const { userInfo } = this.props
    if (userInfo.email !== '') {
      handleFireflySendEvent(
        'PAGE_VIEW',
        'Cabling',
        'Cabling Page Load',
        userInfo,
      )
    }
  }

  static defaultProps = {
    userInfo: {
      lanId: undefined,
      email: undefined,
    },
  }

  handleTabChange(event, newTab) {
    this.setState({
      selectedTab: newTab,
    })
  }

  render() {
    const { classes, userInfo } = this.props
    return (
      <div>
        <HeaderTitle title="Cabling" />
        {this.state.loading ? (
          <Grid
            container
            spacing={16}
            justifyContent={'center'}
            className="progress"
          >
            <CircularProgress />
            <Typography className="loading">&nbsp;Loading...</Typography>
          </Grid>
        ) : (
          <Grid item size={{ xs: 12 }} style={{ margin: 5 }}>
            <Card style={{ height: '75vh' }}>
              <AppBar position="static">
                <Tabs
                  value={this.state.selectedTab}
                  onChange={this.handleTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  <Tab label="Cabling Type Sync" />
                  <Tab label="Switch and Patch Panel Layout" />
                  <Tab label="Patch Cable Counts" />
                </Tabs>
              </AppBar>
              {this.state.selectedTab === 0 && (
                <CablingTypesTab classes={classes} user={userInfo} />
              )}
              {this.state.selectedTab === 1 && (
                <CablingLayoutsTab
                  classes={classes}
                  user={userInfo}
                  handleHelpOpen={this.state.handleHelpOpen}
                />
              )}
              {this.state.selectedTab === 2 && (
                <PatchCableCountsTab classes={classes} user={userInfo} />
              )}
            </Card>
          </Grid>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.auth.userInfo,
  }
}

export default connect(mapStateToProps)(Cabling)
